/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum VendorType {
    Retail = 'Retail',
    Consign = 'Consign',
    CrossDock = 'CrossDock',
    ShipBySeller = 'ShipBySeller',
}

export enum SubOrderSecondaryStatusReason {
    CustomerAbsence = 'CustomerAbsence',
    RejectedByCustomer = 'RejectedByCustomer',
    WrongAddress = 'WrongAddress',
    OutOfSupportedZone = 'OutOfSupportedZone',
    NotPickedByDriver = 'NotPickedByDriver',
    WithoutPoD = 'WithoutPoD',
    DriverProblem = 'DriverProblem',
}

export enum SubOrderSecondaryStatus {
    Draft = 'Draft',
    Submitted = 'Submitted',
    ProcessWmsCreated = 'ProcessWmsCreated',
    ProcessWmsWaitToConfirm = 'ProcessWmsWaitToConfirm',
    ProcessWmsConfirmed = 'ProcessWmsConfirmed',
    ProcessWmsLacked = 'ProcessWmsLacked',
    ProcessWmsInProcessLacked = 'ProcessWmsInProcessLacked',
    ProcessWmsCompleted = 'ProcessWmsCompleted',
    ProcessStarted = 'ProcessStarted',
    ProcessInProgress = 'ProcessInProgress',
    ProcessPending = 'ProcessPending',
    ProcessCompleted = 'ProcessCompleted',
    ProcessCanceled = 'ProcessCanceled',
    Cancelled = 'Cancelled',
    Shipping = 'Shipping',
    DeliveryAssigned = 'DeliveryAssigned',
    DeliveredToCourier = 'DeliveredToCourier',
    DeliveryStarted = 'DeliveryStarted',
    DeliveryWaiting = 'DeliveryWaiting',
    DeliveryNoReceiver = 'DeliveryNoReceiver',
    InPudo = 'InPudo',
    DeliveryCanceled = 'DeliveryCanceled',
    DeliveryRejected = 'DeliveryRejected',
    DeliveryCompleted = 'DeliveryCompleted',
}

export enum SubOrderPrimaryStatus {
    Draft = 'Draft',
    Submitted = 'Submitted',
    Processing = 'Processing',
    Cancelled = 'Cancelled',
    Shipping = 'Shipping',
    ShippingCompleted = 'ShippingCompleted',
}

export enum SubOrderFlag {
    Lack = 'Lack',
    LackInProcess = 'LackInProcess',
    PoNotReceived = 'PoNotReceived',
    FailedInitShipment = 'FailedInitShipment',
}

export enum SbsOrderStatus {
    Settled = 'Settled',
    Processing = 'Processing',
    Shipped = 'Shipped',
    Canceled = 'Canceled',
    Delivered = 'Delivered',
}

export enum SbsDeliveryType {
    VendorCourier = 'VendorCourier',
    Post = 'Post',
    Tipax = 'Tipax',
    Mahex = 'Mahex',
}

export enum ReturnItemRestockResultRequest {
    BackToShelf = 'BackToShelf',
    OpenBox = 'OpenBox',
    Wastage = 'Wastage',
    BackToSeller = 'BackToSeller',
    Missing = 'Missing',
    RefundWithoutReturn = 'RefundWithoutReturn',
    Acquire = 'Acquire',
    Consign = 'Consign',
}

export enum ReturnItemReasonTypeRequest {
    CustomerReturn = 'CustomerReturn',
    FailedCustomer = 'FailedCustomer',
    FailedKhanoumi = 'FailedKhanoumi',
    LackItem = 'LackItem',
    LostItem = 'LostItem',
    FailedSeller = 'FailedSeller',
}

export enum ReturnItemCostCenterTypeRequest {
    Commercial = 'Commercial',
    Marketing = 'Marketing',
    Sales = 'Sales',
    OpsOutbound = 'OpsOutbound',
    OpsLogistic = 'OpsLogistic',
    OpsInbound = 'OpsInbound',
    OpsCrm = 'OpsCrm',
    OpsContent = 'OpsContent',
    Customer = 'Customer',
    BusinessDevelopment = 'BusinessDevelopment',
    Brand = 'Brand',
    Finance = 'Finance',
    HrAndAdminOffice = 'HrAndAdminOffice',
    HrAndAdminOps = 'HrAndAdminOps',
    It = 'It',
    Management = 'Management',
    Operation = 'Operation',
    OpsFirstMile = 'OpsFirstMile',
    OpsManagement = 'OpsManagement',
    OpsPlanning = 'OpsPlanning',
    OpsRentAndMaintenance = 'OpsRentAndMaintenance',
    OpsReverse = 'OpsReverse',
    Product = 'Product',
    Strategy = 'Strategy',
    Supply = 'Supply',
    Tech = 'Tech',
    Seller = 'Seller',
}

export enum PromotionOfferType {
    FixInPurchasePrice = 'FixInPurchasePrice',
    PercentageInPurchasePrice = 'PercentageInPurchasePrice',
    FreeShipping = 'FreeShipping',
    Gift = 'Gift',
}

export enum PaymentStatusType {
    Pending = 'Pending',
    Succeeded = 'Succeeded',
    Failed = 'Failed',
}

export enum OrderStatus {
    Draft = 'Draft',
    PaymentPending = 'PaymentPending',
    PaymentSettled = 'PaymentSettled',
    PaymentCanceled = 'PaymentCanceled',
    Processing = 'Processing',
    Shipped = 'Shipped',
}

export enum OrderReturnReasonType {
    AbsenceOfCustomer = 'AbsenceOfCustomer',
    CancellationOfPurchaseOfTheEntireOrder = 'CancellationOfPurchaseOfTheEntireOrder',
    CanceledBeforeShipping = 'CanceledBeforeShipping',
    MissingAfterShipping = 'MissingAfterShipping',
}

export enum OrderListStatus {
    Processing = 'Processing',
    Shipped = 'Shipped',
    Canceled = 'Canceled',
}

export enum LineItemReturnCostCenterType {
    Commercial = 'Commercial',
    Marketing = 'Marketing',
    Sales = 'Sales',
    Outbound = 'Outbound',
    Logistic = 'Logistic',
    Inbound = 'Inbound',
    Crm = 'Crm',
    Content = 'Content',
    Customer = 'Customer',
    PostOffice = 'PostOffice',
    WithoutCost = 'WithoutCost',
    BusinessDevelopment = 'BusinessDevelopment',
    Brand = 'Brand',
    Finance = 'Finance',
    HrAndAdminOffice = 'HrAndAdminOffice',
    HrAndAdminOps = 'HrAndAdminOps',
    It = 'It',
    Management = 'Management',
    Operation = 'Operation',
    OpsFirstMile = 'OpsFirstMile',
    OpsManagement = 'OpsManagement',
    OpsPlanning = 'OpsPlanning',
    OpsRentAndMaintenance = 'OpsRentAndMaintenance',
    OpsReverse = 'OpsReverse',
    Product = 'Product',
    Strategy = 'Strategy',
    Supply = 'Supply',
    Tech = 'Tech',
    Seller = 'Seller',
}

export enum LineItemRestockStatusType {
    BackToShelf = 'BackToShelf',
    OpenBox = 'OpenBox',
    Wastage = 'Wastage',
    BackToSeller = 'BackToSeller',
    Missing = 'Missing',
    RefundWithoutReturn = 'RefundWithoutReturn',
    Acquire = 'Acquire',
    Consign = 'Consign',
}

export enum LineItemChangeReasonType {
    OutOfStock = 'OutOfStock',
    DissatisfactionWithThePrice = 'DissatisfactionWithThePrice',
    NotReceivedASN = 'NotReceivedASN',
    CancellationOfPurchase = 'CancellationOfPurchase',
    InProcessLack = 'InProcessLack',
    LackInReceivedASN = 'LackInReceivedASN',
}

export enum GatewayType {
    SnappPay = 'SnappPay',
    PardakhtNovin = 'PardakhtNovin',
    PayPing = 'PayPing',
    Zify = 'Zify',
    Parsian = 'Parsian',
    ParsianToSina = 'ParsianToSina',
    ParsianToMellat = 'ParsianToMellat',
    ParsianToPasargad = 'ParsianToPasargad',
    ParsianToTejarat = 'ParsianToTejarat',
    ParsianToKeshavarzi = 'ParsianToKeshavarzi',
    Credit = 'Credit',
    SepToRefah = 'SepToRefah',
    SepToSaderat = 'SepToSaderat',
    Sep725 = 'Sep725',
    Sep728 = 'Sep728',
    Sep729 = 'Sep729',
    SepToPayPing = 'SepToPayPing',
    SepToKarAfarin = 'SepToKarAfarin',
    Vandar = 'Vandar',
    Zarinpal = 'Zarinpal',
    Card = 'Card',
    Pasargad = 'Pasargad',
    Sepehr = 'Sepehr',
    Tara = 'Tara',
    Digipay = 'Digipay',
    Bazarpay = 'Bazarpay',
    Azki = 'Azki',
    Toman = 'Toman',
    PardakhtNovinV2 = 'PardakhtNovinV2',
    AsanToShahr = 'AsanToShahr',
    AsanToDay = 'AsanToDay',
}

export enum ErpErrorType {
    NotEnoughInventory = 'NotEnoughInventory',
    Backdate = 'Backdate',
    EarlierFailed = 'EarlierFailed',
    Unspecified = 'Unspecified',
    InvalidSbu = 'InvalidSbu',
    InvalidLocation = 'InvalidLocation',
    InvalidLotNumber = 'InvalidLotNumber',
}

export enum DeliveryType {
    TehranExpress = 'TehranExpress',
    NormalPost = 'NormalPost',
    Tipax = 'Tipax',
    InOfficeDelivery = 'InOfficeDelivery',
    OldNormalPost = 'OldNormalPost',
    PriorityPost = 'PriorityPost',
    SameDayDelivery = 'SameDayDelivery',
    PriorityExpressPost = 'PriorityExpressPost',
    KhanoumiExpress = 'KhanoumiExpress',
    QazvinExpress = 'QazvinExpress',
    JabarShahrakGharb = 'JabarShahrakGharb',
    UrbanExpress = 'UrbanExpress',
    Alborz = 'Alborz',
    Postex = 'Postex',
    Speed = 'Speed',
    DigiExpress = 'DigiExpress',
    Agent5 = 'Agent5',
    SelfPickup = 'SelfPickup',
    Mahex = 'Mahex',
    Test = 'Test',
}

export enum DeliveryTimeSlotChangedReason {
    BackToCustomer = 'BackToCustomer',
    DelayInProcess = 'DelayInProcess',
    DelayInDelivery = 'DelayInDelivery',
    FailDeliverCustomer = 'FailDeliverCustomer',
    FailDeliverOperation = 'FailDeliverOperation',
}

export enum CancelOrderReasonType {
    DelayInDelivery = 'DelayInDelivery',
    SnappPayDiscountCode = 'SnappPayDiscountCode',
    DissatisfactionWithProductRemoval = 'DissatisfactionWithProductRemoval',
    MissingOrder = 'MissingOrder',
    CancellationOfPurchase = 'CancellationOfPurchase',
    Fraud = 'Fraud',
    PriceFluctuation = 'PriceFluctuation',
}

export enum AggregatedGatewayType {
    Bank = 'Bank',
    SnappPay = 'SnappPay',
    Tara = 'Tara',
    Digipay = 'Digipay',
    Credit = 'Credit',
}

export enum AdminOrderStatus {
    Draft = 'Draft',
    PaymentPending = 'PaymentPending',
    PaymentSettled = 'PaymentSettled',
    PaymentCanceled = 'PaymentCanceled',
    Processing = 'Processing',
    Shipped = 'Shipped',
    Canceled = 'Canceled',
    Returned = 'Returned',
}

export interface AdminCustomerViewModel {
    /** @format int32 */
    customerId?: number
    name?: string | null
    receiverName?: string | null
    phoneNumber?: string | null
    receiverPhoneNumber?: string | null
}

export interface AdminDriverViewModel {
    driverName?: string | null
    driverPhoneNumber?: string | null
}

export interface AdminLineItemViewModel {
    id?: string | null
    productId?: string | null
    productName?: string | null
    colorName?: string | null
    imageUrl?: string | null
    weightUnit?: string | null
    weightNetValue?: string | null
    /** @format int32 */
    quantity?: number
    /** @format int64 */
    basePrice?: number
    /** @format int64 */
    salesPrice?: number
    /** @format int64 */
    discountPrice?: number
    /** @format int64 */
    totalSalesPrice?: number
    vendorName?: string | null
    isDeleted?: boolean
    deleteReason?: string | null
    /** @format date-time */
    deletedAt?: string | null
    restockCase?: LineItemRestockStatusType
    deleteCostCenter?: LineItemReturnCostCenterType
    version?: string | null
    isGift?: boolean
    giftParentItemId?: string | null
    productDetailUrl?: string | null
    /** @format int32 */
    outOfStockQuantity?: number | null
    isPromotionOffer?: boolean
    /** @format int32 */
    poId?: number | null
    /** @format date-time */
    poPromisedDate?: string | null
    /** @format date-time */
    poReceivedDate?: string | null
    linePoNotSettle?: boolean
    linePoDelay?: boolean
    linePoPromise?: boolean
    vendorType?: VendorType
    /** @format int32 */
    atpId?: number
    isReturned?: boolean
}

export interface AdminOrderViewModel {
    /** @format uuid */
    orderId?: string
    orderNumber?: string | null
    /** @format date-time */
    createdAt?: string
    status?: AdminOrderStatus
    /** @format int64 */
    finalTotalPrice?: number
    /** @format int64 */
    totalSalesPrice?: number
    /** @format int64 */
    totalPromotionAmount?: number | null
    /** @format int64 */
    shippingCost?: number
    voucherCode?: string | null
    version?: string | null
    cancelReason?: string | null
    /** @format date-time */
    cancelledAt?: string | null
    /** @format int64 */
    isDeletedTotalSalesPrice?: number
    /** @format int64 */
    isReturnedTotalSalesPrice?: number
    customer?: AdminCustomerViewModel
    subOrders?: AdminSubOrderViewModel[] | null
    payment?: AdminPaymentViewModel
    promotionOfferType?: PromotionOfferType
    /** @format int64 */
    initialPromotionAmount?: number
    /** @format date-time */
    processingDate?: string | null
    /** @format date-time */
    packScanDate?: string | null
    vendorDisplayName?: string | null
    isShipBySeller?: boolean
    vendorId?: string | null
    orderDetailFlag?: string | null
}

export interface AdminOrderViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: AdminOrderViewModel
}

export interface AdminPaymentViewModel {
    id?: string | null
    /** @format int64 */
    amount?: number
    status?: PaymentStatusType
    /** @format date-time */
    settledAt?: string | null
    transactions?: AdminTransactionViewModel[] | null
}

export interface AdminShipmentViewModel {
    address?: string | null
    cityName?: string | null
    provinceName?: string | null
    postalCode?: string | null
    /** @format date */
    shippingDate?: string | null
    /** @format time */
    fromTime?: string | null
    /** @format time */
    toTime?: string | null
    /** @format date */
    fromDate?: string | null
    /** @format date */
    toDate?: string | null
    deliveryCode?: string | null
    trackingCode?: string | null
    deliveryType?: DeliveryType
    /** @format int64 */
    minimumFreeDeliveryPrice?: number
    driverInfo?: AdminDriverViewModel
    changeHistories?: ChangeOrderDeliveryTimeSlotHistoryViewModel[] | null
}

export interface AdminSubOrderViewModel {
    /** @format uuid */
    id?: string
    /** @format int64 */
    finalTotalPrice?: number
    /** @format int64 */
    shippingCost?: number
    /** @format int64 */
    effectiveShippingCost?: number
    shippingStatus?: SubOrderSecondaryStatus
    /** @format int64 */
    totalItemsDiscountAmount?: number | null
    /** @format date */
    processingDueDate?: string | null
    shipment?: AdminShipmentViewModel
    lineItems?: AdminLineItemViewModel[] | null
    flag?: SubOrderFlag
    /** @format date-time */
    processWmsCompletedOccurredAt?: string | null
}

export interface AdminTransactionViewModel {
    /** @format int64 */
    amount?: number
    reserveNumber?: string | null
    referenceNumber?: string | null
    gatewayType?: GatewayType
    /** @format date-time */
    createdAt?: string
}

export interface CancelOrderRequest {
    reasonType?: CancelOrderReasonType
    /** @minLength 1 */
    version: string
}

export interface ChangeOrderDeliveryTimeSlotHistoryDetailViewModel {
    timeSlotId?: string | null
    /** @format time */
    fromTime?: string | null
    /** @format time */
    toTime?: string | null
    /** @format date */
    fromDate?: string | null
    /** @format date */
    toDate?: string | null
}

export interface ChangeOrderDeliveryTimeSlotHistoryViewModel {
    /** @format int64 */
    id?: number
    /** @format uuid */
    orderId?: string
    /** @format uuid */
    subOrderId?: string
    occurredByDisplayName?: string | null
    from?: ChangeOrderDeliveryTimeSlotHistoryDetailViewModel
    to?: ChangeOrderDeliveryTimeSlotHistoryDetailViewModel
    /** @format date-time */
    occurredAt?: string
    reason?: DeliveryTimeSlotChangedReason
}

export interface ChangeOrderTimeSlotRequest {
    /** @minLength 1 */
    capacityId: string
    /** @format int64 */
    timeSlotId: number
    /** @format uuid */
    subOrderId: string
    reason?: DeliveryTimeSlotChangedReason
}

export interface ConfirmOrdersToStartWmsProcessItems {
    /** @format uuid */
    orderId?: string
    /** @format uuid */
    subOrderId?: string
    orderPickApproach?: boolean
}

export interface ConfirmOrdersToStartWmsProcessRequest {
    items?: ConfirmOrdersToStartWmsProcessItems[] | null
}

export interface ConfirmOrdersToStartWmsProcessViewModel {
    /** @format int32 */
    numberOfOrders?: number
}

export interface ConfirmOrdersToStartWmsProcessViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: ConfirmOrdersToStartWmsProcessViewModel
}

export interface ConfirmWmsLackRequest {
    items?: WmsLackItem[] | null
}

export interface ConfirmWmsLackResultViewModel {
    /** @format int32 */
    numberOfOrders?: number
}

export interface ConfirmWmsLackResultViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: ConfirmWmsLackResultViewModel
}

export interface CustomerInfoDetailViewModel {
    receiverName?: string | null
    receiverPhoneNumber?: string | null
}

export interface DeleteNotReceivedPoItemsRequest {
    items?: NotReceivedPoItemRequest[] | null
}

export interface DeleteNotReceivedPoResultViewModel {
    succeeded?: string[] | null
    failed?: string[] | null
}

export interface DeleteNotReceivedPoResultViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: DeleteNotReceivedPoResultViewModel
}

export interface EditOrderRequest {
    /** @minLength 1 */
    lineItemId: string
    /** @format int32 */
    quantity: number
    reasonType?: LineItemChangeReasonType
    /** @minLength 1 */
    version: string
}

export interface EnvelopError {
    code?: string | null
    message?: string | null
    property?: string | null
    attemptedValue?: any
    details?: string | null
}

export interface ErpReturnOrderRequest {
    /** @minLength 1 */
    lineItemId: string
    /** @format int32 */
    quantity: number
    reason?: ReturnItemReasonTypeRequest
    result?: ReturnItemRestockResultRequest
    costCenter?: ReturnItemCostCenterTypeRequest
    /** @format date-time */
    deletedAt?: string
}

export interface ErpSyncItems {
    orderId?: string | null
    lineItemId?: string | null
}

export interface FailureEnvelop {
    isSuccess?: boolean
    errors?: IEnvelopError[] | null
}

export interface GetFailedErpSyncItemsViewModel {
    orderNumber?: string | null
    orderId?: string | null
    lineItemId?: string | null
    /** @format date */
    shippedDate?: string
    /** @format date-time */
    createdAt?: string
    variantCode?: string | null
    productName?: string | null
    vendorType?: VendorType
    errorType?: ErpErrorType
    /** @format int32 */
    quantity?: number
    errorCode?: string | null
    errorMessage?: string | null
}

export interface GetFailedErpSyncItemsViewModelPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: GetFailedErpSyncItemsViewModel[] | null
}

export interface GetFailedErpSyncItemsViewModelPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetFailedErpSyncItemsViewModelPaginationViewModel
}

export interface GetOrderDetailViewModel {
    orderNumber?: string | null
    /** @format date-time */
    createdAt?: string
    /** @format int64 */
    finalTotalAmount?: number
    /** @format int64 */
    credit?: number
    isCanceled?: boolean
    /** @format int64 */
    totalGiftAndPromotionAmount?: number | null
    deliveryTypeTitle?: string | null
    gatewayType?: AggregatedGatewayType
    customer?: CustomerInfoDetailViewModel
    subOrders?: SubOrderItemViewModel[] | null
}

export interface GetOrderDetailViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetOrderDetailViewModel
}

export interface GetOrderListViewModel {
    id?: string | null
    orderNumber?: string | null
    /** @format date-time */
    createdAt?: string
    /** @format int64 */
    finalTotalPrice?: number
    status?: AdminOrderStatus
    cancelReason?: string | null
    /** @format date-time */
    cancelledAt?: string | null
    subOrders?: SubOrderDetailViewModel[] | null
}

export interface GetOrderListViewModelPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: GetOrderListViewModel[] | null
}

export interface GetOrderListViewModelPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetOrderListViewModelPaginationViewModel
}

export interface GetSubOrderListViewModel {
    /** @format uuid */
    id?: string
    /** @format uuid */
    orderId?: string
    orderNumber?: string | null
    /** @format int32 */
    itemCount?: number
    /** @format date-time */
    createdAt?: string
    /** @format date */
    shippedDate?: string | null
    deliveryType?: DeliveryType
    receiverName?: string | null
    secondaryStatus?: SubOrderSecondaryStatus
    /** @format time */
    deliveryTimeSlotFrom?: string | null
    /** @format time */
    deliveryTimeSlotTo?: string | null
    poIds?: (number | null)[]
    flags?: SubOrderFlag
    linePoNotSettle?: boolean
    linePoPromise?: boolean
    linePoDelay?: boolean
}

export interface GetSubOrderListViewModelPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: GetSubOrderListViewModel[] | null
}

export interface GetSubOrderListViewModelPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetSubOrderListViewModelPaginationViewModel
}

export interface GetUserOrderListViewModel {
    orderNumber?: string | null
    /** @format date-time */
    createdAt?: string
    /** @format int64 */
    finalTotalAmount?: number
    isCanceled?: boolean
    status?: SubOrderSecondaryStatus
    secondaryStatusReason?: SubOrderSecondaryStatusReason
    deliveryType?: DeliveryType
    lineItems?: LineItemListViewModel[] | null
}

export interface GetUserOrderListViewModelPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: GetUserOrderListViewModel[] | null
}

export interface GetUserOrderListViewModelPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetUserOrderListViewModelPaginationViewModel
}

export interface GetVendorOrderViewModel {
    orderNumber?: string | null
    /** @format date-time */
    createdAt?: string
    /** @format int64 */
    basePrice?: number
    /** @format int64 */
    salesPrice?: number
    /** @format int32 */
    quantity?: number
    /** @format int32 */
    atpId?: number
    imageUrl?: string | null
    slug?: string | null
    brand?: string | null
    productName?: string | null
}

export interface GetVendorOrderViewModelListSuccessEnvelop {
    isSuccess?: boolean
    data?: GetVendorOrderViewModel[] | null
}

export interface GetVendorOrderViewModelPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: GetVendorOrderViewModel[] | null
}

export interface GetVendorOrderViewModelPaginationViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: GetVendorOrderViewModelPaginationViewModel
}

export interface GoldPropertyViewModel {
    /** @format int64 */
    goldPrice?: number
    /** @format int64 */
    goldValue?: number
    /** @format double */
    makingFeePercent?: number
    /** @format double */
    vendorMargin?: number
    /** @format double */
    vatPercent?: number
    /** @format int64 */
    nonGoldComponentCost?: number
    /** @format int64 */
    makingFeeAmount?: number
    /** @format int64 */
    marginAmount?: number
    /** @format int64 */
    vatAmount?: number
    /** @format double */
    weightNetValue?: number
}

export interface IEnvelopError {
    code?: string | null
    message?: string | null
    property?: string | null
    attemptedValue?: any
    details?: string | null
}

export interface LineItemDetailViewModel {
    productName?: string | null
    brandName?: string | null
    colorName?: string | null
    colorImageUrl?: string | null
    productSlug?: string | null
    imageUrl?: string | null
    /** @format int32 */
    quantity?: number
    /** @format int64 */
    basePrice?: number
    /** @format int64 */
    discountPrice?: number
    /** @format int64 */
    totalSalesPrice?: number
    isDeleted?: boolean
    isGift?: boolean
    giftParentItemId?: string | null
    hasPricingGift?: boolean
    isPromotionOffer?: boolean
}

export interface LineItemListViewModel {
    imageUrl?: string | null
    /** @format int32 */
    quantity?: number
}

export interface NotReceivedPoItemRequest {
    /** @format uuid */
    orderId?: string
    /** @format uuid */
    subOrderId?: string
}

export interface OrderListViewModel {
    orderNumber?: string | null
    /** @format date-time */
    createdAt?: string
    /** @format double */
    totalAmount?: number
    isCancelled?: boolean
    orderStatus?: OrderStatus
    subOrderPrimaryStatus?: SubOrderPrimaryStatus
    subOrderSecondaryStatus?: SubOrderSecondaryStatus
    /** @format date */
    deliveryPromiseFrom?: string | null
    /** @format date */
    deliveryPromiseTo?: string | null
    /** @format time */
    deliveryTimeSlotFrom?: string | null
    /** @format time */
    deliveryTimeSlotTo?: string | null
    deliveryType?: DeliveryType
    trackingCode?: string | null
}

export interface OrderListViewModelListSuccessEnvelop {
    isSuccess?: boolean
    data?: OrderListViewModel[] | null
}

export interface OrderReturnRequest {
    /** @minLength 1 */
    version: string
    reasonType?: OrderReturnReasonType
    restockStatusType?: LineItemRestockStatusType
    costCenterType?: LineItemReturnCostCenterType
}

export interface ProblemDetails {
    type?: string | null
    title?: string | null
    /** @format int32 */
    status?: number | null
    detail?: string | null
    instance?: string | null
    [key: string]: any
}

export interface RetryFailedErpSyncItemsRequest {
    items?: ErpSyncItems[] | null
}

export interface RetryFailedErpSyncItemsResultViewModel {
    /** @format int32 */
    successCount?: number
}

export interface RetryFailedErpSyncItemsResultViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: RetryFailedErpSyncItemsResultViewModel
}

export interface RetryShipmentInitCommandRequest {
    items?: string[] | null
}

export interface RetryShipmentInitCommandResponseViewModel {
    succeeded?: string[] | null
    failed?: string[] | null
}

export interface RetryShipmentInitCommandResponseViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: RetryShipmentInitCommandResponseViewModel
}

export interface ReturnOrderItemRequest {
    /** @minLength 1 */
    lineItemId: string
    /** @format int32 */
    quantity: number
    reasonType?: ReturnItemReasonTypeRequest
    restockStatusType?: ReturnItemRestockResultRequest
    costCenterType?: ReturnItemCostCenterTypeRequest
    /** @minLength 1 */
    version: string
}

export interface SbsOrderStatusCountViewModel {
    /** @format int32 */
    settledCount?: number
    /** @format int32 */
    processingCount?: number
    /** @format int32 */
    shippedCount?: number
    /** @format int32 */
    canceledCount?: number
    /** @format int32 */
    deliveredCount?: number
}

export interface SendEmailRequest {
    /** @minLength 1 */
    toEmail: string
    /** @minLength 1 */
    toName: string
    /** @minLength 1 */
    body: string
    /** @minLength 1 */
    subject: string
    sender: SenderOptions
}

export interface SendUserCreditEmailRequest {
    /** @minLength 1 */
    shebaNumber: string
    /** @minLength 1 */
    accountOwner: string
}

export interface SenderOptions {
    fromEmail?: string | null
    name?: string | null
    password?: string | null
    host?: string | null
    /** @format int32 */
    port?: number
}

export interface SetStatusRequest {
    orderStatus?: OrderStatus
    primaryStatus?: SubOrderPrimaryStatus
    secondaryStatus?: SubOrderSecondaryStatus
}

export interface ShipmentInfoDetailViewModel {
    address?: string | null
    cityName?: string | null
    provinceName?: string | null
    postalCode?: string | null
    /** @format time */
    fromTime?: string | null
    /** @format time */
    toTime?: string | null
    /** @format date */
    fromDate?: string | null
    /** @format date */
    toDate?: string | null
    deliveryCode?: string | null
    trackingCode?: string | null
    deliveryType?: DeliveryType
    hasDailyTimeSlot?: boolean
}

export interface StringSuccessEnvelop {
    isSuccess?: boolean
    data?: string | null
}

export interface SubOrderDetailViewModel {
    id?: string | null
    /** @format date */
    shippingDate?: string | null
    /** @format time */
    startTimeSlot?: string | null
    /** @format time */
    endTimeSlot?: string | null
    shippingStatus?: SubOrderSecondaryStatus
    deliveryType?: DeliveryType
    province?: string | null
    city?: string | null
    receiverName?: string | null
    /** @format date-time */
    processWmsCompletedOccurredAt?: string | null
}

export interface SubOrderItemViewModel {
    /** @format int64 */
    effectiveShippingCost?: number
    status?: SubOrderSecondaryStatus
    secondaryStatusReason?: SubOrderSecondaryStatusReason
    shipment?: ShipmentInfoDetailViewModel
    lineItems?: LineItemDetailViewModel[] | null
}

export interface SuccessEnvelop {
    isSuccess?: boolean
    data?: any
}

export interface UserViewModel {
    /** @format uuid */
    id?: string
}

export interface UserViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: UserViewModel
}

export interface VendorSbsOrderHeaderViewModel {
    /** @format int64 */
    orderNumber?: number
    /** @format date-time */
    createdAt?: string
    /** @format uuid */
    orderId?: string
    /** @format date */
    deliveryPromisedAt?: string
    deliveryCity?: string | null
    deliveryProvince?: string | null
    /** @format int32 */
    quantity?: number
    /** @format int32 */
    count?: number
    isReturned?: boolean
    cancelReason?: string | null
    /** @format date-time */
    cancelledAt?: string | null
    items?: VendorSbsOrderItemViewModel[] | null
}

export interface VendorSbsOrderHeaderViewModelPaginationViewModel {
    /** @format int32 */
    totalCount?: number
    /** @format int32 */
    pageNumber?: number
    /** @format int32 */
    pageSize?: number
    items?: VendorSbsOrderHeaderViewModel[] | null
}

export interface VendorSbsOrderInvoiceItemViewModel {
    name?: string | null
    vendorAtpCode?: string | null
    /** @format int32 */
    quantity?: number
    /** @format int64 */
    subTotalAmount?: number
    pricingMetadata?: GoldPropertyViewModel
}

export interface VendorSbsOrderInvoiceViewModel {
    customerName?: string | null
    customerPhone?: string | null
    nationalId?: string | null
    address?: string | null
    postalCode?: string | null
    items?: VendorSbsOrderInvoiceItemViewModel[] | null
    /** @format int64 */
    totalPrice?: number
    /** @format int64 */
    shippingCost?: number
}

export interface VendorSbsOrderInvoiceViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: VendorSbsOrderInvoiceViewModel
}

export interface VendorSbsOrderItemViewModel {
    /** @format uuid */
    id?: string
    name?: string | null
    color?: string | null
    /** @format double */
    weightNetValue?: number
    /** @format int32 */
    quantity?: number
    /** @format int64 */
    totalPrice?: number
    imageUrl?: string | null
    slug?: string | null
    /** @format int64 */
    basePrice?: number
    /** @format int64 */
    salesPrice?: number
    isReturned?: boolean
    isDeleted?: boolean
    deleteReason?: string | null
    vendorAtpCode?: string | null
    /** @format int32 */
    atpId?: number
}

export interface VendorSbsOrderListViewModel {
    data?: VendorSbsOrderHeaderViewModelPaginationViewModel
    statusCount?: SbsOrderStatusCountViewModel
}

export interface VendorSbsOrderListViewModelSuccessEnvelop {
    isSuccess?: boolean
    data?: VendorSbsOrderListViewModel
}

export interface VendorSbsOrderStatusToShipRequest {
    deliveryType?: SbsDeliveryType
    trackingCode?: string | null
}

export interface WmsLackItem {
    /** @format uuid */
    orderId?: string
    /** @format uuid */
    subOrderId?: string
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean
    /** request path */
    path: string
    /** content type of request body */
    type?: ContentType
    /** query params */
    query?: QueryParamsType
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseFormat
    /** request body */
    body?: unknown
    /** base url */
    baseUrl?: string
    /** request cancellation token */
    cancelToken?: CancelToken
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> {
    baseUrl?: string
    baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
    securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void
    customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
    data: D
    error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
    Json = 'application/json',
    JsonApi = 'application/vnd.api+json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
    public baseUrl: string = ''
    private securityData: SecurityDataType | null = null
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
    private abortControllers = new Map<CancelToken, AbortController>()
    private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams)

    private baseApiParams: RequestParams = {
        credentials: 'same-origin',
        headers: {},
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
    }

    constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
        Object.assign(this, apiConfig)
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data
    }

    protected encodeQueryParam(key: string, value: any) {
        const encodedKey = encodeURIComponent(key)
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
    }

    protected addQueryParam(query: QueryParamsType, key: string) {
        return this.encodeQueryParam(key, query[key])
    }

    protected addArrayQueryParam(query: QueryParamsType, key: string) {
        const value = query[key]
        return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
    }

    protected toQueryString(rawQuery?: QueryParamsType): string {
        const query = rawQuery || {}
        const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key])
        return keys
            .map((key) =>
                Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)
            )
            .join('&')
    }

    protected addQueryParams(rawQuery?: QueryParamsType): string {
        const queryString = this.toQueryString(rawQuery)
        return queryString ? `?${queryString}` : ''
    }

    private contentFormatters: Record<ContentType, (input: any) => any> = {
        [ContentType.Json]: (input: any) =>
            input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
        [ContentType.JsonApi]: (input: any) =>
            input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
        [ContentType.Text]: (input: any) =>
            input !== null && typeof input !== 'string' ? JSON.stringify(input) : input,
        [ContentType.FormData]: (input: any) => {
            if (input instanceof FormData) {
                return input
            }

            return Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key]
                formData.append(
                    key,
                    property instanceof Blob
                        ? property
                        : typeof property === 'object' && property !== null
                          ? JSON.stringify(property)
                          : `${property}`
                )
                return formData
            }, new FormData())
        },
        [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
    }

    protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        }
    }

    protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken)
            if (abortController) {
                return abortController.signal
            }
            return void 0
        }

        const abortController = new AbortController()
        this.abortControllers.set(cancelToken, abortController)
        return abortController.signal
    }

    public abortRequest = (cancelToken: CancelToken) => {
        const abortController = this.abortControllers.get(cancelToken)

        if (abortController) {
            abortController.abort()
            this.abortControllers.delete(cancelToken)
        }
    }

    public request = async <T = any, E = any>({
        body,
        secure,
        path,
        type,
        query,
        format,
        baseUrl,
        cancelToken,
        ...params
    }: FullRequestParams): Promise<HttpResponse<T, E>> => {
        const secureParams =
            ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {}
        const requestParams = this.mergeRequestParams(params, secureParams)
        const queryString = query && this.toQueryString(query)
        const payloadFormatter = this.contentFormatters[type || ContentType.Json]
        const responseFormat = format || requestParams.format

        return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
            },
            signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
            body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
        }).then(async (response) => {
            const r = response as HttpResponse<T, E>
            r.data = null as unknown as T
            r.error = null as unknown as E

            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                      .then((data) => {
                          if (r.ok) {
                              r.data = data
                          } else {
                              r.error = data
                          }
                          return r
                      })
                      .catch((e) => {
                          r.error = e
                          return r
                      })

            if (cancelToken) {
                this.abortControllers.delete(cancelToken)
            }

            if (!response.ok) throw data
            return data
        })
    }
}

/**
 * @title Squidward
 * @version v1
 *
 * Squidward back-end (Web API)
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
    api = {
        /**
         * No description
         *
         * @tags ContactUs
         * @name SqwV1ContactUsCreate
         * @request POST:/api/sqw/v1/contact-us
         */
        sqwV1ContactUsCreate: (
            data: {
                Name: string
                MobileNumber: string
                Email?: string
                Message?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, EnvelopError>({
                path: `/api/sqw/v1/contact-us`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Erp
         * @name V1ErpOrdersReturnCreate
         * @request POST:/api/v1/erp/orders/{id}/return
         */
        v1ErpOrdersReturnCreate: (id: string, data: ErpReturnOrderRequest[], params: RequestParams = {}) =>
            this.request<void, EnvelopError | ProblemDetails>({
                path: `/api/v1/erp/orders/${id}/return`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwVendorV1OrdersMyList
         * @request GET:/api/sqw/vendor/v1/orders/my
         * @deprecated
         */
        sqwVendorV1OrdersMyList: (
            query?: {
                /** @default false */
                shipped?: boolean
                /** @format int32 */
                atp_id?: number
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 10
                 */
                page_size?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<GetVendorOrderViewModelPaginationViewModelSuccessEnvelop, FailureEnvelop | void>({
                path: `/api/sqw/vendor/v1/orders/my`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwVendorV1OrdersMyList2
         * @request GET:/api/sqw/vendor/v1/orders/_my
         * @originalName sqwVendorV1OrdersMyList
         * @duplicate
         */
        sqwVendorV1OrdersMyList2: (
            query?: {
                /** @default false */
                po_created?: boolean
                /** @format int32 */
                atp_id?: number
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 10
                 */
                page_size?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<GetVendorOrderViewModelPaginationViewModelSuccessEnvelop, FailureEnvelop | void>({
                path: `/api/sqw/vendor/v1/orders/_my`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwVendorV1OrdersMyExcelList
         * @request GET:/api/sqw/vendor/v1/orders/my/_excel
         * @deprecated
         */
        sqwVendorV1OrdersMyExcelList: (
            query?: {
                /** @default false */
                shipped?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<GetVendorOrderViewModelListSuccessEnvelop, FailureEnvelop | void>({
                path: `/api/sqw/vendor/v1/orders/my/_excel`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwVendorV1OrdersMyExcelList2
         * @request GET:/api/sqw/vendor/v1/orders/_my/_excel
         * @originalName sqwVendorV1OrdersMyExcelList
         * @duplicate
         */
        sqwVendorV1OrdersMyExcelList2: (
            query?: {
                /** @default false */
                po_created?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<GetVendorOrderViewModelListSuccessEnvelop, FailureEnvelop | void>({
                path: `/api/sqw/vendor/v1/orders/_my/_excel`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwV1OrdersMyList
         * @request GET:/api/sqw/v1/orders/_my
         */
        sqwV1OrdersMyList: (
            query?: {
                /** @default "" */
                order_number?: string
                status?: OrderListStatus
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 10
                 */
                page_size?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<GetUserOrderListViewModelPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/v1/orders/_my`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwV1OrdersMyOrderNumberDetail
         * @request GET:/api/sqw/v1/orders/_my/order-number/{orderNumber}
         */
        sqwV1OrdersMyOrderNumberDetail: (orderNumber: string, params: RequestParams = {}) =>
            this.request<GetOrderDetailViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/v1/orders/_my/order-number/${orderNumber}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwInternalOrdersRetryShipmentInitCommandCreate
         * @request POST:/api/sqw/internal/orders/retry-shipment-init-command
         */
        sqwInternalOrdersRetryShipmentInitCommandCreate: (
            data: RetryShipmentInitCommandRequest,
            params: RequestParams = {}
        ) =>
            this.request<RetryShipmentInitCommandResponseViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/internal/orders/retry-shipment-init-command`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1OrdersIdReturnPartialUpdate
         * @request PATCH:/api/sqw/admin/v1/orders/id/{id}/return
         */
        sqwAdminV1OrdersIdReturnPartialUpdate: (id: string, data: OrderReturnRequest, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/orders/id/${id}/return`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1OrdersIdReturnItemsPartialUpdate
         * @request PATCH:/api/sqw/admin/v1/orders/id/{id}/return-items
         */
        sqwAdminV1OrdersIdReturnItemsPartialUpdate: (
            id: string,
            data: ReturnOrderItemRequest[],
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/orders/id/${id}/return-items`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1OrdersOrderNumberUserList
         * @request GET:/api/sqw/admin/v1/orders/order_number/{orderNumber}/user
         */
        sqwAdminV1OrdersOrderNumberUserList: (orderNumber: string, params: RequestParams = {}) =>
            this.request<UserViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/orders/order_number/${orderNumber}/user`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1SubOrdersList
         * @request GET:/api/sqw/admin/v1/sub-orders
         */
        sqwAdminV1SubOrdersList: (
            query?: {
                order_number?: string
                /** @format date */
                start_delivery_date?: string
                /** @format date */
                end_delivery_date?: string
                /** @format int32 */
                line_item_diversity?: number
                contain_crossDock?: boolean
                include_atp?: string
                exception_atp?: string
                delivery_type?: DeliveryType
                /** @format time */
                delivery_time_slot_from?: string
                /** @format time */
                delivery_time_slot_to?: string
                order_status?: SubOrderSecondaryStatus
                flag?: SubOrderFlag
                po_not_settle?: boolean
                po_promise_date?: boolean
                po_delay?: boolean
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 10
                 */
                page_size?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<GetSubOrderListViewModelPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/sub-orders`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1OrdersShippedOrderNumberDetail
         * @request GET:/api/sqw/admin/v1/orders/shipped/order_number/{orderNumber}
         */
        sqwAdminV1OrdersShippedOrderNumberDetail: (orderNumber: string, params: RequestParams = {}) =>
            this.request<AdminOrderViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/orders/shipped/order_number/${orderNumber}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1SubOrdersOutOfStockList
         * @request GET:/api/sqw/admin/v1/sub-orders/out-of-stock
         */
        sqwAdminV1SubOrdersOutOfStockList: (
            query?: {
                order_number?: string
                /** @format date */
                start_delivery_date?: string
                /** @format date */
                end_delivery_date?: string
                contain_crossDock?: boolean
                po_not_settle?: boolean
                po_promise_date?: boolean
                out_of_stock_type?: SubOrderFlag
                suborder_status?: SubOrderSecondaryStatus
                include_atp?: string
                exception_atp?: string
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 10
                 */
                page_size?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<GetSubOrderListViewModelPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/sub-orders/out-of-stock`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1OrdersList
         * @request GET:/api/sqw/admin/v1/orders
         */
        sqwAdminV1OrdersList: (
            query?: {
                order_number?: string
                status?: AdminOrderStatus
                shipping_status?: SubOrderSecondaryStatus
                delivery_type?: DeliveryType
                phone_number?: string
                /** @format date */
                start_delivery_date?: string
                /** @format date */
                end_delivery_date?: string
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 10
                 */
                page_size?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<GetOrderListViewModelPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/orders`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1OrdersOrderNumberDetail
         * @request GET:/api/sqw/admin/v1/orders/order_number/{orderNumber}
         */
        sqwAdminV1OrdersOrderNumberDetail: (orderNumber: string, params: RequestParams = {}) =>
            this.request<AdminOrderViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/orders/order_number/${orderNumber}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1NotReceivedPoSubOrdersList
         * @request GET:/api/sqw/admin/v1/not-received-po-sub-orders
         */
        sqwAdminV1NotReceivedPoSubOrdersList: (
            query?: {
                order_number?: string
                /** @format date */
                start_delivery_date?: string
                /** @format date */
                end_delivery_date?: string
                /** @format int32 */
                line_item_diversity?: number
                contain_crossDock?: boolean
                include_atp?: string
                exception_atp?: string
                include_po?: string
                exception_po?: string
                delivery_type?: DeliveryType
                /** @format time */
                delivery_time_slot_from?: string
                /** @format time */
                delivery_time_slot_to?: string
                order_status?: SubOrderSecondaryStatus
                po_not_settle?: boolean
                po_promise_date?: boolean
                po_delay?: boolean
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 10
                 */
                page_size?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<GetSubOrderListViewModelPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/not-received-po-sub-orders`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1OrdersPhoneNumberDetail
         * @request GET:/api/sqw/admin/v1/orders/phone-number/{phoneNumber}
         */
        sqwAdminV1OrdersPhoneNumberDetail: (phoneNumber: string, params: RequestParams = {}) =>
            this.request<OrderListViewModelListSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/orders/phone-number/${phoneNumber}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1ErpRetryCreate
         * @request POST:/api/sqw/admin/v1/erp/retry
         */
        sqwAdminV1ErpRetryCreate: (data: RetryFailedErpSyncItemsRequest, params: RequestParams = {}) =>
            this.request<RetryFailedErpSyncItemsResultViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/erp/retry`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1ErpGetFailedItemsList
         * @request GET:/api/sqw/admin/v1/erp/get-failed-items
         */
        sqwAdminV1ErpGetFailedItemsList: (
            query?: {
                variant_code?: string
                error_type?: ErpErrorType
                vendor_type?: VendorType
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 10
                 */
                page_size?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<GetFailedErpSyncItemsViewModelPaginationViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/erp/get-failed-items`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1ErpGetFailedItemsExcelList
         * @request GET:/api/sqw/admin/v1/erp/get-failed-items/_excel
         */
        sqwAdminV1ErpGetFailedItemsExcelList: (params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/erp/get-failed-items/_excel`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1OrdersIdDecreaseItemQtyPartialUpdate
         * @request PATCH:/api/sqw/admin/v1/orders/id/{id}/decrease-item-qty
         */
        sqwAdminV1OrdersIdDecreaseItemQtyPartialUpdate: (
            id: string,
            data: EditOrderRequest[],
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/orders/id/${id}/decrease-item-qty`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1OrdersDeleteNotReceivedPoCreate
         * @request POST:/api/sqw/admin/v1/orders/delete-not-received-po
         */
        sqwAdminV1OrdersDeleteNotReceivedPoCreate: (
            data: DeleteNotReceivedPoItemsRequest,
            params: RequestParams = {}
        ) =>
            this.request<DeleteNotReceivedPoResultViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/orders/delete-not-received-po`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1OrdersWmsConfirmationExcelSampleFileList
         * @request GET:/api/sqw/admin/v1/orders/wms-confirmation/_excel/sample-file
         */
        sqwAdminV1OrdersWmsConfirmationExcelSampleFileList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/sqw/admin/v1/orders/wms-confirmation/_excel/sample-file`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1OrdersWmsConfirmationExcelCreate
         * @request POST:/api/sqw/admin/v1/orders/wms-confirmation/_excel
         */
        sqwAdminV1OrdersWmsConfirmationExcelCreate: (
            data: {
                /** @format binary */
                file?: File
            },
            params: RequestParams = {}
        ) =>
            this.request<ConfirmOrdersToStartWmsProcessViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/orders/wms-confirmation/_excel`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1OrdersWmsConfirmationCreate
         * @request POST:/api/sqw/admin/v1/orders/wms-confirmation
         */
        sqwAdminV1OrdersWmsConfirmationCreate: (
            data: ConfirmOrdersToStartWmsProcessRequest,
            params: RequestParams = {}
        ) =>
            this.request<ConfirmOrdersToStartWmsProcessViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/orders/wms-confirmation`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1OrdersLackConfirmationCreate
         * @request POST:/api/sqw/admin/v1/orders/lack-confirmation
         */
        sqwAdminV1OrdersLackConfirmationCreate: (data: ConfirmWmsLackRequest, params: RequestParams = {}) =>
            this.request<ConfirmWmsLackResultViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/orders/lack-confirmation`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1OrdersUpdateTimeslotPartialUpdate
         * @request PATCH:/api/sqw/admin/v1/orders/{id}/update-timeslot
         */
        sqwAdminV1OrdersUpdateTimeslotPartialUpdate: (
            id: string,
            data: ChangeOrderTimeSlotRequest,
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/orders/${id}/update-timeslot`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1OrdersChangeTimeslotPartialUpdate
         * @request PATCH:/api/sqw/admin/v1/orders/{id}/change-timeslot
         */
        sqwAdminV1OrdersChangeTimeslotPartialUpdate: (
            id: string,
            data: ChangeOrderTimeSlotRequest,
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/orders/${id}/change-timeslot`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SqwAdminV1OrdersIdCancelPartialUpdate
         * @request PATCH:/api/sqw/admin/v1/orders/id/{id}/cancel
         */
        sqwAdminV1OrdersIdCancelPartialUpdate: (id: string, data: CancelOrderRequest, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/orders/id/${id}/cancel`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags OrderReminder
         * @name SqwAdminV1OrdersIdCallRemindersCreate
         * @request POST:/api/sqw/admin/v1/orders/id/{id}/call-reminders
         */
        sqwAdminV1OrdersIdCallRemindersCreate: (id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/sqw/admin/v1/orders/id/${id}/call-reminders`,
                method: 'POST',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShipBySeller
         * @name SqwVendorV1SbsOrdersShipCreate
         * @request POST:/api/sqw/vendor/v1/sbs/orders/{id}/ship
         */
        sqwVendorV1SbsOrdersShipCreate: (
            id: string,
            data: VendorSbsOrderStatusToShipRequest,
            params: RequestParams = {}
        ) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/vendor/v1/sbs/orders/${id}/ship`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShipBySeller
         * @name SqwVendorV1SbsOrdersProcessCreate
         * @request POST:/api/sqw/vendor/v1/sbs/orders/{id}/process
         */
        sqwVendorV1SbsOrdersProcessCreate: (id: string, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/vendor/v1/sbs/orders/${id}/process`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShipBySeller
         * @name SqwVendorV1SbsOrdersMyList
         * @request GET:/api/sqw/vendor/v1/sbs/orders/_my
         */
        sqwVendorV1SbsOrdersMyList: (
            query: {
                status: SbsOrderStatus
                /** @format int64 */
                order_number?: number
                /**
                 * @format int32
                 * @default 1
                 */
                page_number?: number
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 10
                 */
                page_size?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<VendorSbsOrderListViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/vendor/v1/sbs/orders/_my`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShipBySeller
         * @name SqwVendorV1SbsOrdersMyExcelList
         * @request GET:/api/sqw/vendor/v1/sbs/orders/my/_excel
         */
        sqwVendorV1SbsOrdersMyExcelList: (
            query?: {
                status?: SbsOrderStatus
            },
            params: RequestParams = {}
        ) =>
            this.request<VendorSbsOrderListViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/vendor/v1/sbs/orders/my/_excel`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShipBySeller
         * @name SqwVendorV1SbsOrdersInvoiceList
         * @request GET:/api/sqw/vendor/v1/sbs/orders/{id}/invoice
         */
        sqwVendorV1SbsOrdersInvoiceList: (id: string, params: RequestParams = {}) =>
            this.request<VendorSbsOrderInvoiceViewModelSuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/vendor/v1/sbs/orders/${id}/invoice`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ShipBySeller
         * @name SqwAdminV1SbsOrdersCompleteDeliveryCreate
         * @request POST:/api/sqw/admin/v1/sbs/orders/{id}/complete-delivery
         */
        sqwAdminV1SbsOrdersCompleteDeliveryCreate: (id: string, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/api/sqw/admin/v1/sbs/orders/${id}/complete-delivery`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Sitak
         * @name V1SitakOrdersOrderNumberStatusCreate
         * @request POST:/api/v1/sitak/orders/order_number/{orderNumber}/status
         */
        v1SitakOrdersOrderNumberStatusCreate: (orderNumber: string, params: RequestParams = {}) =>
            this.request<number, any>({
                path: `/api/v1/sitak/orders/order_number/${orderNumber}/status`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UserCredit
         * @name SqwV1CreditsMyRefundCreate
         * @request POST:/api/sqw/v1/credits/_my/refund
         */
        sqwV1CreditsMyRefundCreate: (data: SendUserCreditEmailRequest, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, EnvelopError>({
                path: `/api/sqw/v1/credits/_my/refund`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    }
    internal = {
        /**
         * No description
         *
         * @tags Debug
         * @name DebugKibaHttpClientHandlerList
         * @request GET:/__internal/debug/kiba-http-client-handler
         */
        debugKibaHttpClientHandlerList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/kiba-http-client-handler`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugKibaWorkersList
         * @request GET:/__internal/debug/kiba-workers
         */
        debugKibaWorkersList: (
            query?: {
                name?: string
                is_enabled?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/debug/kiba-workers`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugShippingOptionsList
         * @request GET:/__internal/debug/shipping-options
         */
        debugShippingOptionsList: (
            query: {
                userId: string
                mobileNumber: string
                cityId: string
                shippingMethodId: string
                timeSlotId: string
                /** @format int32 */
                leadTime: number
                /** @format int32 */
                cartTotalSum?: number
                /** @default "1" */
                distributionCenterId?: string
                /** @format double */
                latitude?: number
                /** @format double */
                longitude?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/debug/shipping-options`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugShipmentAdapterInitOrderIdDetail
         * @request GET:/__internal/debug/shipment-adapter/init/order-id/{orderId}
         */
        debugShipmentAdapterInitOrderIdDetail: (
            orderId: string,
            query?: {
                deliveryType?: DeliveryType
            },
            params: RequestParams = {}
        ) =>
            this.request<any, FailureEnvelop>({
                path: `/__internal/debug/shipment-adapter/init/order-id/${orderId}`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugGrainsOrdersRefreshList
         * @request GET:/__internal/debug/grains/orders/{id}/refresh
         */
        debugGrainsOrdersRefreshList: (id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/grains/orders/${id}/refresh`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugGrainsOrdersRefreshCreate
         * @request POST:/__internal/debug/grains/orders/refresh
         */
        debugGrainsOrdersRefreshCreate: (data: string[], params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/grains/orders/refresh`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugGrainsOrdersDetail
         * @request GET:/__internal/debug/grains/orders/{id}
         */
        debugGrainsOrdersDetail: (id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/grains/orders/${id}`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugEmailCreate
         * @request POST:/__internal/debug/email
         */
        debugEmailCreate: (data: SendEmailRequest, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/email`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugMonitoringUnprocessedIntegrationEventsCountList
         * @request GET:/__internal/debug/monitoring/unprocessed-integration-events-count
         */
        debugMonitoringUnprocessedIntegrationEventsCountList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/monitoring/unprocessed-integration-events-count`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugRabbitQueuesList
         * @request GET:/__internal/debug/rabbit/queues
         */
        debugRabbitQueuesList: (
            query?: {
                search_key?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/debug/rabbit/queues`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugRabbitQueuesNameRetryCreate
         * @request POST:/__internal/debug/rabbit/queues/name/{queue_name}/retry
         */
        debugRabbitQueuesNameRetryCreate: (queueName: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/rabbit/queues/name/${queueName}/retry`,
                method: 'POST',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugSamianRawList
         * @request GET:/__internal/debug/samian/raw
         */
        debugSamianRawList: (
            query: {
                path: string
                accessToken: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/debug/samian/raw`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugSamianRawOrdersOrderNumberDetail
         * @request GET:/__internal/debug/samian/raw/orders/order-number/{orderNumber}
         */
        debugSamianRawOrdersOrderNumberDetail: (
            orderNumber: number,
            query: {
                accessToken: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/debug/samian/raw/orders/order-number/${orderNumber}`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugSamianRawOrdersWmsIdDetail
         * @request GET:/__internal/debug/samian/raw/orders/wms-id/{wmsId}
         */
        debugSamianRawOrdersWmsIdDetail: (
            wmsId: number,
            query: {
                accessToken: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/debug/samian/raw/orders/wms-id/${wmsId}`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugSamianRawOrdersWmsIdDetailsList
         * @request GET:/__internal/debug/samian/raw/orders/wms-id/{wmsId}/details
         */
        debugSamianRawOrdersWmsIdDetailsList: (
            wmsId: number,
            query: {
                accessToken: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/debug/samian/raw/orders/wms-id/${wmsId}/details`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugSamianRawAccessTokenCreate
         * @request POST:/__internal/debug/samian/raw/access-token
         */
        debugSamianRawAccessTokenCreate: (
            data: {
                username: string
                password: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/debug/samian/raw/access-token`,
                method: 'POST',
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Debug
         * @name DebugSamianOrderNumberDetail
         * @request GET:/__internal/debug/samian/order-number/{orderNumber}
         */
        debugSamianOrderNumberDetail: (orderNumber: number, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/__internal/debug/samian/order-number/${orderNumber}`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags ExitDateQueue
         * @name ExitDateQueueDequeueCreate
         * @request POST:/__internal/exit-date-queue/{queueType}/dequeue
         */
        exitDateQueueDequeueCreate: (
            queueType: string,
            query?: {
                orderId?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/exit-date-queue/${queueType}/dequeue`,
                method: 'POST',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags ExitDateQueue
         * @name ExitDateQueueEnqueueCreate
         * @request POST:/__internal/exit-date-queue/{queueType}/enqueue
         */
        exitDateQueueEnqueueCreate: (
            queueType: string,
            query?: {
                /** @example "0.00:00:00" */
                waitTime?: string
                orderId?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/exit-date-queue/${queueType}/enqueue`,
                method: 'POST',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags ExitDateQueue
         * @name ExitDateQueueItemsList
         * @request GET:/__internal/exit-date-queue/{queueType}/items
         */
        exitDateQueueItemsList: (
            queueType: string,
            query?: {
                orderId?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/__internal/exit-date-queue/${queueType}/items`,
                method: 'GET',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name OrdersPaymentPendingStatusCountList
         * @request GET:/__internal/orders/__payment-pending-status/count
         */
        ordersPaymentPendingStatusCountList: (
            query?: {
                /**
                 * @format double
                 * @default 60
                 */
                max_age_days?: number
                /**
                 * @format double
                 * @default 30
                 */
                min_age_minutes?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<number, any>({
                path: `/__internal/orders/__payment-pending-status/count`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name OrdersSoldOrderItemsExcelList
         * @request GET:/__internal/orders/__sold_order_items/excel
         */
        ordersSoldOrderItemsExcelList: (
            query?: {
                /** @format date-time */
                start?: string
                /** @format date-time */
                end?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<number, any>({
                path: `/__internal/orders/__sold_order_items/excel`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name OrdersCalculateCreate
         * @request POST:/__internal/orders/calculate
         */
        ordersCalculateCreate: (data: string[], params: RequestParams = {}) =>
            this.request<StringSuccessEnvelop, EnvelopError>({
                path: `/__internal/orders/calculate`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name SbsOrdersShipInfoUpdate
         * @request PUT:/__internal/sbs/orders/{id}/ship-info
         */
        sbsOrdersShipInfoUpdate: (id: string, data: VendorSbsOrderStatusToShipRequest, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/__internal/sbs/orders/${id}/ship-info`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name OrdersSetTotalStatusCreate
         * @request POST:/__internal/orders/{id}/set-total-status
         */
        ordersSetTotalStatusCreate: (id: string, data: SetStatusRequest, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/__internal/orders/${id}/set-total-status`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Order
         * @name OrdersProcessingInitDetail
         * @request GET:/__internal/orders/processing/init/{id}
         */
        ordersProcessingInitDetail: (id: string, params: RequestParams = {}) =>
            this.request<SuccessEnvelop, FailureEnvelop>({
                path: `/__internal/orders/processing/init/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    }
}
